export const StarIcon = ({ className, color =  '#FA9600'}: { className?: string, color?: string }) => (
  <svg
    width='19'
    height='17'
    viewBox='0 0 19 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M9.49983 14.27L13.6498 16.78C14.4098 17.24 15.3398 16.56 15.1398 15.7L14.0398 10.98L17.7098 7.80001C18.3798 7.22001 18.0198 6.12001 17.1398 6.05001L12.3098 5.64001L10.4198 1.18001C10.0798 0.37001 8.91983 0.37001 8.57983 1.18001L6.68983 5.63001L1.85983 6.04001C0.979829 6.11001 0.619828 7.21001 1.28983 7.79001L4.95983 10.97L3.85983 15.69C3.65983 16.55 4.58983 17.23 5.34983 16.77L9.49983 14.27Z'
      fill={color}
    />
  </svg>
);
